import { render } from "./blogPostPublico.vue?vue&type=template&id=2655119a&scoped=true"
import script from "./blogPostPublico.vue?vue&type=script&lang=js"
export * from "./blogPostPublico.vue?vue&type=script&lang=js"

import "./blogPostPublico.vue?vue&type=style&index=0&id=2655119a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2655119a"]])

export default __exports__